const CEP_RANGES = [
  [1000, 19999, 'SP'],
  [20000, 28999, 'RJ'],
  [29000, 29999, 'ES'],
  [30000, 39999, 'MG'],
  [40000, 48999, 'BA'],
  [49000, 49999, 'SE'],
  [50000, 56999, 'PE'],
  [57000, 57999, 'AL'],
  [58000, 58999, 'PB'],
  [59000, 59999, 'RN'],
  [60000, 63999, 'CE'],
  [64000, 64999, 'PI'],
  [65000, 65999, 'MA'],
  [66000, 68899, 'PA'],
  [68900, 68999, 'AP'],
  [69000, 69299, 'AM'],
  [69300, 69399, 'RR'],
  [69400, 69899, 'AM'],
  [69900, 69999, 'AC'],
  [70000, 72799, 'DF'],
  [72800, 72999, 'GO'],
  [73000, 73699, 'DF'],
  [73700, 76799, 'GO'],
  [76800, 76999, 'RO'],
  [77000, 77999, 'TO'],
  [78000, 78899, 'MT'],
  [79000, 79999, 'MS'],
  [80000, 87999, 'PR'],
  [88000, 89999, 'SC'],
  [90000, 99999, 'RS'],
];

const formatBRL = (value) =>
  Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const provinceFromCep = (cep) => {
  const prefix = Number(cep.slice(0, 5));
  const range = CEP_RANGES.find(([start, end]) => prefix >= start && prefix <= end);
  return range ? range[2] : null;
};

class RwShippingCalculator extends HTMLElement {
  #bound = false;

  get input() {
    return this.querySelector('input');
  }

  get results() {
    return this.querySelector('[data-results]');
  }

  get button() {
    return this.querySelector('button');
  }

  connectedCallback() {
    if (this.#bound) return;
    this.#bound = true;
    this.addEventListener('input', (event) => {
      if (event.target !== this.input) return;
      const digits = this.input.value.replace(/\D/g, '').slice(0, 8);
      this.input.value = digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
    });
    this.addEventListener('submit', (event) => {
      event.preventDefault();
      this.calculate();
    });
  }

  showMessage(text) {
    this.results.innerHTML = '';
    const message = document.createElement('p');
    message.className = 'rw-shipping__message';
    message.textContent = text;
    this.results.append(message);
  }

  async calculate() {
    const cep = this.input.value.replace(/\D/g, '');
    const province = provinceFromCep(cep);
    if (cep.length !== 8 || !province) {
      this.showMessage('Informe um CEP válido.');
      return;
    }

    this.button.disabled = true;
    this.showMessage('Calculando...');

    const root = window.Shopify?.routes?.root || '/';
    const params = new URLSearchParams({
      'shipping_address[zip]': `${cep.slice(0, 5)}-${cep.slice(5)}`,
      'shipping_address[country]': 'Brazil',
      'shipping_address[province]': province,
    });

    try {
      const prepare = await fetch(`${root}cart/prepare_shipping_rates.json?${params}`, { method: 'POST' });
      if (!prepare.ok) throw new Error('prepare');

      let rates = null;
      for (let attempt = 0; attempt < 15 && !rates; attempt++) {
        const response = await fetch(`${root}cart/async_shipping_rates.json?${params}`);
        const data = response.ok ? await response.json() : null;
        if (data && data.shipping_rates) {
          rates = data.shipping_rates;
        } else {
          await new Promise((resolve) => setTimeout(resolve, 700));
        }
      }

      if (!rates) throw new Error('timeout');
      if (rates.length === 0) {
        this.showMessage('Nenhuma opção de frete disponível para este CEP.');
        return;
      }

      const list = document.createElement('ul');
      list.className = 'rw-shipping__rates';
      rates.forEach((rate) => {
        const item = document.createElement('li');
        item.className = 'rw-shipping__rate';
        const name = document.createElement('span');
        name.className = 'rw-shipping__rate-name';
        name.textContent = rate.description ? `${rate.name} (${rate.description})` : rate.name;
        const price = document.createElement('span');
        price.className = 'rw-shipping__rate-price';
        price.textContent = Number(rate.price) === 0 ? 'Grátis' : formatBRL(rate.price);
        item.append(name, price);
        list.append(item);
      });
      this.results.innerHTML = '';
      this.results.append(list);
    } catch (error) {
      this.showMessage('Não foi possível calcular o frete. Tente novamente.');
    } finally {
      this.button.disabled = false;
    }
  }
}

if (!customElements.get('rw-shipping-calculator')) {
  customElements.define('rw-shipping-calculator', RwShippingCalculator);
}
